import { render, staticRenderFns } from "./CharterListSummary.vue?vue&type=template&id=767cb241&scoped=true&"
import script from "./CharterListSummary.vue?vue&type=script&lang=js&"
export * from "./CharterListSummary.vue?vue&type=script&lang=js&"
import style0 from "./CharterListSummary.vue?vue&type=style&index=0&id=767cb241&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cb241",
  null
  
)

export default component.exports